import { combineReducers } from 'redux';
import userData from './User';
import driverData from './Global';

export default combineReducers({
  userData,
  driverData,
});
